export const contractTypeIds = {
    undefined: 0,
    // Создание договора
    paid: 2,
    // Договор с тендерных площадок (Загрузка)
    tender: 3,
    // Договор с государственных закупок (Загрузка)
    governmentPurchase: 4,
    // КСЭК (Загрузка документа)
    governmentOrder: 5
}